import styled from "@emotion/styled"
import SearchIcon from "@mui/icons-material/Search"
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material"
import { memo, useContext } from "react"
import { ServiceCentersContext } from "./ServiceCentersContext"

const Styled = {
  FormLabel: styled(FormControlLabel)`
    margin-top: 15px;
    align-items: center;
  `,
  CheckboxLabel: styled(Typography)`
    color: ${(p) => p.theme.colors.marine};
    line-height: 1.2;
    font-weight: bold;
  `,
}

const CitySearch = () => {
  const { setCity, cities, inHesder, setInHesder, setSelectedCenter } =
    useContext(ServiceCentersContext)
  return (
    <>
      <Autocomplete
        id="cityAutocomplete"
        popupIcon={<SearchIcon color="primary" />}
        forcePopupIcon={true}
        options={cities}
        color="primary"
        renderInput={(params) => (
          <TextField {...params} label="חפש עיר" variant="outlined" />
        )}
        autoHighlight
        onChange={(_, value) => {
          setCity(value)
          setSelectedCenter(null)
        }}
      />
      <Styled.FormLabel
        control={
          <Checkbox
            id="inHesderCheckbox"
            name="inHesderCheckbox"
            checked={inHesder}
            color="primary"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setInHesder(event.target.checked)
              setSelectedCenter(null)
            }}
          />
        }
        label={
          <Styled.CheckboxLabel variant="body2">
            {
              'מרכזי שירות המורשים הנכללים בהסדר דלק מוטורס סוכנות לביטוח (2003) בע"מ'
            }
          </Styled.CheckboxLabel>
        }
      />
      {inHesder}
    </>
  )
}

export default memo(CitySearch)
